import { render } from "./NotFound.vue?vue&type=template&id=836392bc&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=836392bc&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836392bc"]])

export default __exports__